// API Configuration
const config = {
  apiBaseUrl: process.env.NODE_ENV === 'production' 
    ? 'https://nick-functions-fd-app.azurewebsites.net'
    : ''
};

export default config;

